export function projectClick() {
  console.log('project click!');
  return function (dispatch) {
    dispatch({ type: 'PROJECT_CLICKED' });
  };
}

export function updateIntro(options) {
  let rand = Math.floor(Math.random() * options.length);

  return function (dispatch) {
    dispatch({ type: 'UPDATE_INTRO', payload: options[rand] });
  };
}

export function updatePath(path) {
  return function (dispatch) {
    dispatch({ type: 'UPDATING_PATH', payload: path });
  };
}

export function setTemplate(name) {
  console.log('setting template', name);
  return function (dispatch) {
    dispatch({ type: 'SETTING_TEMPLATE', payload: name });
  };
}

export function setProjectHeight(height) {
  return function (dispatch) {
    dispatch({ type: 'SETTING_PROJECT_HEIGHT', payload: height });
  };
}

export function dataLoading() {
  return function (dispatch) {
    dispatch({ type: 'DATA_LOADING' });
  };
}

export function dataLoaded() {
  return function (dispatch) {
    dispatch({ type: 'DATA_LOADED' });
  };
}

export function siteReady() {
  return function (dispatch) {
    dispatch({ type: 'SITE_READY' });
  };
}

export function showNav() {
  return function (dispatch) {
    dispatch({ type: 'NAV_OPEN' });
  };
}

export function hideNav() {
  return function (dispatch) {
    dispatch({ type: 'NAV_CLOSED' });
  };
}

export function projectScrolled() {
  return function (dispatch) {
    dispatch({ type: 'PROJECT_SCROLLED' });
  };
}

export function projectUnscrolled() {
  return function (dispatch) {
    dispatch({ type: 'PROJECT_UNSCROLLED' });
  };
}



// WEBPACK FOOTER //
// ./src/js/redux/actions/UI.js